export interface EchartsTooltipActionPayload {
  title: string[];
  body: { lines: string[] }[];
}

const isStringArray = (value: unknown): value is string[] =>
  Array.isArray(value) && value.every((item) => typeof item === 'string');

const isTooltipPayload = (
  value: unknown,
): value is EchartsTooltipActionPayload => {
  if (!value || typeof value !== 'object') return false;

  const { title, body } = value as Record<string, unknown>;

  return (
    isStringArray(title) &&
    Array.isArray(body) &&
    body.every((item) => {
      if (!item || typeof item !== 'object') return false;

      return isStringArray((item as Record<string, unknown>)['lines']);
    })
  );
};

export function readEchartsTooltipAction(
  event: Event,
): EchartsTooltipActionPayload | null {
  const { target } = event;

  if (!(target instanceof Element)) return null;

  const action = target.closest<HTMLElement>('[data-echarts-tooltip-action]');
  const { echartsTooltipData: encodedPayload } = action?.dataset ?? {};

  if (!encodedPayload) return null;

  try {
    const payload: unknown = JSON.parse(encodedPayload);

    return isTooltipPayload(payload) ? payload : null;
  } catch {
    return null;
  }
}
